module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "text": ""
          },
          on: {
            "click": function($event) {
              (_vm.showNachricht = true) &&
              (_vm.neuNachricht = true) &&
              (_vm.nachricht = {
                an: [],
                absenderPosition: '',
                message: {},
                absender: {}
              })
            }
          }
        }, on), [_c('v-icon', [_vm._v("add")]), _vm._v("Neue Mail")], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Neue Mail")])]), _vm._v(" "), _c('v-menu', {
    attrs: {
      "offset-y": "",
      "max-width": "500"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [(_vm.versand.length > 0) ? _c('v-card', _vm._g({
          staticClass: "rounded-lg",
          attrs: {
            "outlined": "",
            "width": "250px"
          }
        }, on), [_c('v-progress-linear', {
          staticClass: "caption",
          attrs: {
            "indeterminate": "",
            "height": "24"
          }
        }, [_vm._v("\n              " + _vm._s(_vm.versand.length) + " Nachrichten im Postausgang\n              "), _c('v-btn', {
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.showVersandMenu = true
            }
          }
        }, [_c('v-icon', [_vm._v("info")])], 1)], 1)], 1) : _vm._e()]
      }
    }])
  }, [_vm._v(" "), _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-item', [_c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.alleErneutVersenden()
      }
    }
  }, [_vm._v("Alle versenden")]), _vm._v(" "), _c('span', {
    staticClass: "text-subtitle-2 px-4"
  }, [_vm._v("Alle 5 Sekunden wird eine Mail versendet. Seite nicht schließen.")])], 1), _vm._v(" "), _vm._l((_vm.versand), function(item, index) {
    return _c('v-list-item', {
      key: index
    }, [_c('v-list-item-icon', [_c('v-progress-circular', {
      attrs: {
        "indeterminate": ""
      }
    })], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-subtitle', [_vm._v("\n                " + _vm._s(_vm.$filters.date(item.datum.seconds * 1000, "TDD.MM.YYYY hh:mm")) + " Uhr |\n                " + _vm._s(item.id))]), _vm._v(" "), _c('v-list-item-title', [_vm._v(_vm._s(item.message.subject))]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v("\n                An:\n                "), _vm._l((item.an), function(bbr, index2) {
      return _c('v-chip', {
        key: index2,
        attrs: {
          "label": "",
          "small": ""
        }
      }, [_vm._v("\n                  " + _vm._s(_vm.$filters.user(bbr, _vm.bundesbruder)) + "\n                ")])
    })], 2)], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-tooltip', {
      attrs: {
        "bottom": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-btn', _vm._g({
            attrs: {
              "icon": ""
            },
            on: {
              "click": function($event) {
                return _vm.erneutVersenden(item)
              }
            }
          }, on), [_c('v-icon', [_vm._v("forward_to_inbox")])], 1)]
        }
      }], null, true)
    }, [_vm._v(" "), _c('span', [_vm._v("Scheinbar gibt es ein Problem beim Versenden der Mail. E-Mail erneut senden.")])])], 1)], 1)
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-subheader', {
    staticClass: "mt-2"
  }, [_vm._v("\n            Der Mailversand kann unter Umständen mehrere Minuten dauern. Sollte eine Mail auch nach längerer Zeit im\n            Postausgang sein, kannst du den Versand erneut anstoßen.\n          ")])], 2)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-items', [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Suchen",
      "single-line": "",
      "solo": "",
      "flat": "",
      "hide-details": "",
      "clearable": "",
      "clear-icon": "close"
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-chip', {
    attrs: {
      "small": "",
      "label": "",
      "color": "green",
      "dark": ""
    }
  }, [_vm._v("BETA")])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-card', {
    staticClass: "ma-2 rounded-t-lg pt-1",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('v-tabs', {
    attrs: {
      "grow": ""
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }, [_c('v-tab', [_vm._v("Eingang")]), _vm._v(" "), _c('v-tab', [_vm._v("Gesendet")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    ref: "card",
    staticClass: "pa-0"
  }, [_c('v-virtual-scroll', {
    attrs: {
      "items": _vm.nachrichten,
      "height": _vm.cardHeight,
      "item-height": "68"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var item = ref.item;
        var index = ref.index;

        return [_c('v-list-item', {
          on: {
            "click": function($event) {
              _vm.nachricht = item;
              _vm.handleResize();
            }
          }
        }, [(item.status === 'Error' && item.status) ? _c('v-list-item-action', [_c('v-icon', {
          attrs: {
            "color": "red"
          }
        }, [_vm._v("warning")])], 1) : _vm._e(), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', {
          staticClass: "font-weight-bold"
        }, [(item.absender.position) ? _c('span', [_vm._v(_vm._s(item.absender.position))]) : _vm._e(), _vm._v(" "), (item.absender.name) ? _c('span', [_vm._v(_vm._s(item.absender.name))]) : _vm._e(), _vm._v(" "), (item.von) ? _c('span', [_vm._v(_vm._s(_vm.$filters.user(item.von, _vm.bundesbruder)))]) : _vm._e()]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v("\n                      " + _vm._s(item.message.subject) + "\n                    ")])], 1), _vm._v(" "), _c('v-list-item-action', {
          staticClass: "text-right"
        }, [_vm._v("\n                    " + _vm._s(_vm.$filters.date(item.datum.seconds * 1000, "DD.MM.YYYY"))), _c('br'), _vm._v("\n                    " + _vm._s(_vm.$filters.date(item.datum.seconds * 1000, "hh:mm Uhr")) + "\n                  ")])], 1), _vm._v(" "), _c('v-divider')]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "hidden-xs-only pa-2",
    attrs: {
      "cols": "12",
      "md": "8"
    }
  }, [(_vm.nachricht.id) ? _c('v-card', {
    staticClass: "rounded-t-lg",
    attrs: {
      "outlined": "",
      "height": _vm.cardHeight + 55
    }
  }, [_c('v-card-title', {
    staticClass: "pa-2 pl-4"
  }, [_vm._v("\n            " + _vm._s(_vm.nachricht.message.subject) + "\n            "), _c('v-spacer'), _vm._v(" "), (_vm.nachricht.status) ? _c('v-chip', {
    attrs: {
      "label": "",
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.nachricht.status))]) : _vm._e()], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-2 pl-4 subtitle-2"
  }, [(_vm.nachricht.datum) ? _c('span', [_vm._v(_vm._s(_vm.$filters.date(_vm.nachricht.datum.seconds * 1000, "DD.MM.YYYY um hh:mm Uhr")))]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.duplicateMail(_vm.nachricht)
            }
          }
        }, on), [_c('v-icon', [_vm._v("content_copy")])], 1)]
      }
    }], null, false, 3877771556)
  }, [_vm._v(" "), _c('span', [_vm._v("Mail duplizieren")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.deleteMail(_vm.nachricht.id)
            }
          }
        }, on), [_c('v-icon', [_vm._v("delete")])], 1)]
      }
    }], null, false, 3136820611)
  }, [_vm._v(" "), _c('span', [_vm._v("Mail direkt Löschen")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.erneutVersenden(_vm.nachricht)
            }
          }
        }, on), [_c('v-icon', [_vm._v("outgoing_mail")])], 1)]
      }
    }], null, false, 3337977938)
  }, [_vm._v(" "), _c('span', [_vm._v("Erneut senden"), _c('br'), _c('br'), _vm._v("Die Mail wird ohne bestätigung direkt erneut an die gleichen Empfänger\n                gesendet")])]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showNachrichtenInfo = true;
        _vm.getAnalytics();
      }
    }
  }, [_c('v-icon', [_vm._v("insights")])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "80%",
      "scrollable": ""
    },
    model: {
      value: (_vm.showNachrichtenInfo),
      callback: function($$v) {
        _vm.showNachrichtenInfo = $$v
      },
      expression: "showNachrichtenInfo"
    }
  }, [_c('v-card', {
    attrs: {
      "rounded": "xl",
      "min-height": "300px"
    }
  }, [_c('v-card-title', [_vm._v("\n                  Nachrichten-Log\n                  "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "loading": _vm.loading.mailAnalytics
    },
    on: {
      "click": function($event) {
        return _vm.getAnalytics()
      }
    }
  }, [_c('v-icon', [_vm._v("refresh")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showNachrichtenInfo = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-title', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-wrap justify-space-around align-center"
  }, _vm._l((_vm.stats), function(item, key, index) {
    return _c('div', {
      key: index,
      staticClass: "d-flex flex-column align-center mx-4 my-2"
    }, [_c('v-progress-circular', {
      attrs: {
        "value": (item.value / _vm.totalRecipients) * 100,
        "color": item.color,
        "size": "80",
        "width": "8",
        "rotate": "-90",
        "indeterminate": _vm.loading.mailAnalytics
      }
    }, [_c('strong', [_vm._v(_vm._s(Math.round((item.value / _vm.totalRecipients) * 100)) + "%")])]), _vm._v(" "), _c('div', {
      staticClass: "text-center mt-2"
    }, [_c('strong', [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.value) + " von " + _vm._s(_vm.totalRecipients))])]), _vm._v(" "), _c('v-tooltip', {
      attrs: {
        "bottom": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-btn', _vm._g({
            staticClass: "mt-1",
            attrs: {
              "icon": "",
              "x-small": ""
            }
          }, on), [_c('v-icon', {
            attrs: {
              "small": ""
            }
          }, [_vm._v("help_outline")])], 1)]
        }
      }], null, true)
    }, [_vm._v(" "), _c('v-card', {
      staticClass: "transparent",
      attrs: {
        "flat": "",
        "dark": "",
        "width": "200px"
      }
    }, [_vm._v("\n                              " + _vm._s(item.hint) + "\n                            ")])], 1)], 1)
  }), 0)])], 1)], 1), _vm._v(" "), _c('v-card-text', [(_vm.mailErrors(_vm.nachricht.log).length > 0) ? _c('span', [_c('v-divider'), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.nachricht.log))])], 1) : _vm._e()])], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "subtitle-2 pa-2"
  }, [_vm._v("\n            Von:\n            "), (_vm.nachricht.absender) ? _c('span', [(_vm.nachricht.absender.position) ? _c('span', [_vm._v(_vm._s(_vm.nachricht.absender.position))]) : _vm._e(), _vm._v(" "), (_vm.nachricht.absender.name) ? _c('span', [_vm._v(_vm._s(_vm.nachricht.absender.name))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.nachricht.von) ? _c('span', [_vm._v(_vm._s(_vm.$filters.user(_vm.nachricht.von, _vm.bundesbruder)))]) : _vm._e(), _vm._v(" "), (_vm.nachricht.an) ? _c('div', {
    staticClass: "mt-1"
  }, [_vm._v("\n              An:\n              "), _vm._l((_vm.nachricht.gruppen), function(item2, index2) {
    return _c('v-chip', {
      key: index2 * 2,
      staticClass: "mr-1",
      attrs: {
        "label": "",
        "small": ""
      }
    }, [_c('v-avatar', {
      attrs: {
        "left": ""
      }
    }, [_c('v-icon', [_vm._v("group")])], 1), _vm._v("\n                " + _vm._s(item2) + "\n              ")], 1)
  }), _vm._v(" "), _vm._l((_vm.nachricht.an), function(item, index) {
    return _c('v-chip', {
      key: index * 2 + 1,
      staticClass: "mr-1",
      attrs: {
        "pill": "",
        "small": ""
      }
    }, [_c('v-avatar', {
      attrs: {
        "left": ""
      }
    }, [_c('v-icon', [_vm._v("account_circle")])], 1), _vm._v("\n                " + _vm._s(_vm.$filters.user(item, _vm.bundesbruder)) + "\n              ")], 1)
  }), _vm._v(" "), _vm._l((_vm.nachricht.an_adresse), function(item, index) {
    return _c('v-chip', {
      key: index * 2 + 1,
      staticClass: "mr-1",
      attrs: {
        "pill": "",
        "small": ""
      }
    }, [_vm._v("\n                " + _vm._s(item) + "\n              ")])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.nachricht.an_cc && _vm.nachricht.an_cc.length > 0) ? _c('div', {
    staticClass: "mt-1"
  }, [_vm._v("\n              CC:\n              "), _vm._l((_vm.nachricht.an_cc), function(item, index) {
    return _c('v-chip', {
      key: index,
      staticClass: "mr-1",
      attrs: {
        "pill": "",
        "small": ""
      }
    }, [_c('v-avatar', {
      attrs: {
        "left": ""
      }
    }, [_c('v-icon', [_vm._v("account_circle")])], 1), _vm._v("\n                " + _vm._s(_vm.$filters.user(item, _vm.bundesbruder)) + "\n              ")], 1)
  })], 2) : _vm._e(), _vm._v(" "), (_vm.nachricht.an_bcc && _vm.nachricht.an_bcc.length > 0) ? _c('div', {
    staticClass: "mt-1"
  }, [_vm._v("\n              BCC:\n              "), _vm._l((_vm.nachricht.an_bcc), function(item, index) {
    return _c('v-chip', {
      key: index,
      staticClass: "mr-1",
      attrs: {
        "pill": "",
        "small": ""
      }
    }, [_c('v-avatar', {
      attrs: {
        "left": ""
      }
    }, [_c('v-icon', [_vm._v("account_circle")])], 1), _vm._v("\n                " + _vm._s(_vm.$filters.user(item, _vm.bundesbruder)) + "\n              ")], 1)
  })], 2) : _vm._e(), _vm._v(" "), (_vm.nachricht.attachments && _vm.nachricht.attachments.length > 0) ? _c('div', {
    staticClass: "mt-1"
  }, [_vm._v("\n              Anhang:\n              "), _vm._l((_vm.nachricht.attachments), function(item, index) {
    return _c('v-chip', {
      key: index,
      staticClass: "mr-1",
      attrs: {
        "label": "",
        "small": "",
        "href": item.path,
        "target": "_blank"
      }
    }, [_c('v-avatar', {
      attrs: {
        "left": ""
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("attach_file")])], 1), _vm._v("\n                " + _vm._s(item.filename) + "\n              ")], 1)
  })], 2) : _vm._e()]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "ma-0 pa-0"
  }, [_c('v-sheet', {
    ref: "cardText",
    staticClass: "pa-4",
    staticStyle: {
      "overflow-y": "auto"
    },
    attrs: {
      "max-height": _vm.sheetHeight
    },
    domProps: {
      "innerHTML": _vm._s(_vm.nachricht.message.html)
    }
  })], 1)], 1) : _c('v-card', {
    staticClass: "rounded-lg pt-1",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-subheader', [_vm._v("Nachricht auswählen")])], 1)], 1)], 1), _vm._v(" "), _c('dialogMailNeu', {
    attrs: {
      "visible": _vm.showNachricht,
      "copynachricht": _vm.nachricht
    },
    on: {
      "update:visible": function($event) {
        _vm.showNachricht = $event
      },
      "close": function($event) {
        _vm.showNachricht = false
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7982ceb1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/mail.vue
// module id = 792
// module chunks = 15